import { url_query_encode } from "@pdfking/workflow/utils/urlutilities"
import length from "rfuncs/functions/length"
import map from "rfuncs/functions/map"
import values from "rfuncs/functions/values"

import upload_files from "../../../files/actions/upload_files"
import start_request from "../../../navigation/start_request"
import storage from "../../../state/storage"
import get_django_url from "../../../utils/get_django_url"

export default (outfolder, files_dict, session = null) => {
  const files = values(files_dict)

  if (length(files) > 0)
    return upload_files(files).then(files =>
      get_django_url("upload_outfolders").then(url =>
        start_request(url, {
          change_location: false,
          scroll_control: false,
          data: url_query_encode({
            outfolder,
            session: session || storage.last_session,
            files: map(f => f.file_meta.remote_name, files),
          }),
        })
      )
    )
}
